import type { IconButtonProps } from '@mui/material/IconButton';

import { usePopover } from 'minimal-shared/hooks';

import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';

import { useAuthContext } from 'src/auth/hooks';

import { AccountButton } from './account-button';
import { SignOutButton } from './sign-out-button';

// ----------------------------------------------------------------------

export type AccountPopoverProps = IconButtonProps;

export function AccountPopover({ sx, ...other }: AccountPopoverProps) {
  const { user } = useAuthContext();

  const displayName = `${user?.firstName} ${user?.lastName}`.trim();

  const { open, anchorEl, onClose, onOpen } = usePopover();

  return (
    <>
      <AccountButton onClick={onOpen} displayName={displayName} sx={sx} {...other} />

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ paper: { sx: { width: 240, p: 2 } } }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Avatar alt={displayName} sx={{ width: 40, height: 40 }}>
            {displayName?.charAt(0).toUpperCase()}
          </Avatar>
          <div>
            <Typography variant="subtitle2" noWrap>
              {displayName}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
              {user?.username}
            </Typography>
          </div>
        </div>

        <Divider sx={{ my: 1.5 }} />

        <SignOutButton onClose={onClose} />
      </Popover>
    </>
  );
}
